let decision: boolean | null = null

export function isSampled(rate: number): boolean {
    if (decision === null) decision = Math.random() < rate

    return decision
}

export function resetSamplingDecision(): void {
    decision = null
}
